import { useCallback, useState } from "react";

export type ToastState = {
  message: string;
  type: "success" | "error";
} | null;

export function useToast(durationMs = 3000) {
  const [toast, setToast] = useState<ToastState>(null);

  const showToast = useCallback(
    (message: string, type: "success" | "error" = "success") => {
      setToast({ message, type });
      setTimeout(() => setToast(null), durationMs);
    },
    [durationMs]
  );

  return { toast, showToast };
}
